import { normalizeProjectCategory } from "./constructor_pricing.js";

export function createConstructorState(rawState) {
  const area = parsePositiveNumber(rawState.area);
  const partialArea = parsePositiveNumber(rawState.partialArea);
  const razvortkyArea = parsePositiveNumber(rawState.razvortkyArea);
  const partialSelection = normalizeSelection(rawState.partialSelection);
  const razvortkySelection = normalizeSelection(rawState.razvortkySelection);
  const planningSelection = normalizeSelection(rawState.planningSelection);
  const planningVariants = parseNonNegativeInteger(rawState.planningVariants);

  return {
    area,
    partialArea,
    resolvedPartialArea: partialSelection.checked ? clampArea(partialArea || area, area) : 0,
    razvortkyArea,
    resolvedRazvortkyArea: razvortkySelection.checked ? clampArea(razvortkyArea || area, area) : 0,
    location: (rawState.location || "").trim(),
    currency: rawState.currency || "uah",
    projectCategory: rawState.projectCategory || "",
    projectCategoryKey: normalizeProjectCategory(rawState.projectCategoryKey || rawState.projectCategory),
    projectType: rawState.projectType || "",
    projectTypeLabel: (rawState.projectTypeLabel || "").trim(),
    planningSelection: {
      ...planningSelection,
      quantity: planningVariants,
    },
    specificationSelection: normalizeSelection(rawState.specificationSelection),
    partialSelection,
    singleDraws: normalizeItems(rawState.singleDraws),
    razvortkySelection,
  };
}

export function isConstructorProject(state) {
  return state.projectType === "constructor";
}

export function hasArea(state) {
  return state.area > 0;
}

export function hasLocation(state) {
  return state.location.length > 0;
}

export function shouldEnableLocation(state) {
  return hasArea(state);
}

export function shouldEnableProjectType(state) {
  return Boolean(state.projectCategoryKey) && hasArea(state);
}

export function shouldShowPanels(state) {
  return shouldEnableProjectType(state) && isConstructorProject(state);
}

function parsePositiveNumber(value) {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

function parseNonNegativeInteger(value) {
  const parsed = parseFloat(value);
  if (!Number.isFinite(parsed) || parsed < 0) return 0;
  return Math.floor(parsed);
}

function clampArea(value, area) {
  if (area <= 0) return 0;
  return Math.min(value, area);
}

function normalizeSelection(selection = {}) {
  return {
    checked: Boolean(selection.checked),
    label: selection.label || "",
    priceKey: selection.priceKey || "",
  };
}

function normalizeItems(items = []) {
  return items.map((item) => ({
    checked: Boolean(item.checked),
    label: item.label || "",
    priceKey: item.priceKey || "",
    isRazvortky: Boolean(item.isRazvortky),
  }));
}
